import React from "react";
import "../main.css";
import { componentWidth } from "../constants";

const PanButton = (props) => {
  const PAN_VALUE = 100;

  const handleClick = () => {
    if (props.calculatedPositions.length > 0) {
      let minCalculatedPosition = props.calculatedPositions[0]["left"];

      let last =
        props.calculatedPositions[props.calculatedPositions.length - 1];
      let maxCalculatedPosition = last["left"] + last["width"];

      if (props.direction == "Right") {
        if (
          maxCalculatedPosition >= 0 &&
          maxCalculatedPosition <= componentWidth
        ) {
          props.handlePan(0, props.genome);
        } else {
          props.handlePan(PAN_VALUE, props.genome);
        }
      } else if (props.direction === "Left") {
        if (
          minCalculatedPosition >= 0 &&
          minCalculatedPosition <= componentWidth
        ) {
          props.handlePan(0, props.genome);
        } else {
          props.handlePan(PAN_VALUE, props.genome);
        }
      }
    }
  };

  return (
    <button className="pan-button" onClick={handleClick}>
      {props.label}
    </button>
  );
};

export default PanButton;
